const HourglassIcon = () => (
  <div
    className="flex size-[77px] items-center justify-center motion-reduce:animate-none animate-[spin_2.5s_linear_infinite]"
    aria-hidden
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <g clipPath="url(#clip0_hourglass)">
        <path
          d="M44.2428 37.8814C44.0532 33.8282 50.4986 30.7497 53.8021 25.2543C57.569 18.9881 56.9058 4.80914 56.9058 4.80914L16.3945 6.7041C16.3945 6.7041 17.0578 20.883 21.3931 26.7702C25.1953 31.9333 31.8999 34.3967 32.0894 38.4499C32.279 42.503 25.8337 45.5815 22.5301 51.077C18.7632 57.3432 19.4265 71.5221 19.4265 71.5221L59.9377 69.6272C59.9377 69.6272 59.2745 55.4482 54.9391 49.561C51.137 44.3979 44.4324 41.9345 44.2428 37.8814Z"
          fill="#4AB932"
          fillOpacity="0.1"
        />
        <path
          d="M36.6498 5.75666L20.4453 6.51465C20.4453 6.51465 20.8243 14.6169 23.1341 20.5988C26.1461 28.3993 35.7611 30.1561 36.1402 38.2604C36.5193 46.3647 37.372 64.5927 39.3975 64.498C41.4231 64.4032 40.5703 46.1732 40.1914 38.0709C39.8124 29.9687 49.2233 27.3198 51.492 19.2724C53.2333 13.1009 52.8543 4.99868 52.8543 4.99868L36.6498 5.75666Z"
          fill="#4AB932"
        />
        <path
          d="M63.9873 69.438C64.0376 70.5124 63.6589 71.5628 62.9347 72.358C62.2105 73.1533 61.2001 73.6283 60.1257 73.6786L19.6144 75.5735C18.54 75.6238 17.4896 75.2452 16.6943 74.521C15.8991 73.7968 15.424 72.7863 15.3738 71.7119C15.3235 70.6375 15.7021 69.5871 16.4263 68.7918C17.1505 67.9966 18.161 67.5215 19.2354 67.4713L59.7467 65.5763C60.8211 65.5261 61.8715 65.9047 62.6668 66.6289C63.462 67.3531 63.937 68.3635 63.9873 69.438ZM60.9554 4.61994C61.0056 5.69437 60.627 6.74475 59.9028 7.54002C59.1786 8.33529 58.1681 8.81031 57.0937 8.86056L16.5825 10.7555C15.508 10.8058 14.4577 10.4272 13.6624 9.70298C12.8671 8.97878 12.3921 7.96832 12.3418 6.8939C12.2916 5.81947 12.6702 4.76909 13.3944 3.97382C14.1186 3.17855 15.129 2.70353 16.2035 2.65328L56.7147 0.758313C57.7892 0.708055 58.8395 1.08667 59.6348 1.81087C60.4301 2.53506 60.9051 3.54552 60.9554 4.61994Z"
          fill="#777777"
        />
      </g>
      <defs>
        <clipPath id="clip0_hourglass">
          <rect
            width="73"
            height="73"
            fill="white"
            transform="translate(0 3.41113) rotate(-2.67813)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default HourglassIcon;
